<template>
  <span ref="popup_container">
    <slot></slot>
  </span>
</template>

<script>
import Popper from 'popper.js'
export default {
  name: 'Popup',
  components: {

  },
  mounted(){
    let popup_containers = this.$refs["popup_container"]
		new Popper(popup_containers.firstElementChild, popup_containers.lastElementChild,{
			placement: 'top',
		})
	},
}
</script>

<style lang="scss" scoped>
.popup{
  max-width:300px;
	display: inline-block;
	height: auto !important;
  padding:10px;
  border-radius: 10px;
  box-shadow: 0px 2px 10px 1px  darkgrey;
  background: white;
  border:1px solid lightgrey;
  z-index:10;
	opacity: 0;
  transition: opacity .2s ease-in-out;
	font-size: 12pt;
	text-align: left;
}

.popup-text{
  border-bottom:1px dashed $CTred;
}

.popup-text:hover + .popup, .valid{
	opacity: 1;
}
</style>
